// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__FHYIQ","error":"Notification_error__tLZzK","success":"Notification_success__PqmQC"};